import request from "./index";

// Use the built-in window.btoa directly. The previous wrapper
// unintentionally shadowed the global function and caused
// recursion if called.

export const Account = {
  login: (data) => {
    return request.post(
      `/api/Account/login?email=${data.email}&abcd=${data.PKey}`
    );
  },
  cms_login: (data) => {
    return request.post(`/api/Account/login?email=&abcd=&CMSEmail=${data}`);
  },
  getCurrentUser: () => {
    return request.get("/api/Account");
  },
  // getAgentUsers: () => {
  //   return request.get("/api/Account/OtherAgentUsers");
  // },
  // Update: (data) => {
  //   // console.log('Update data', data);
  //   return request.post(
  //     `/api/Account/Update?newPassword=${data.newPassword}&lastName=${data.lastName}&firstName=${data.firstName}&nickname=${data.nickname}&gender=${data.gender}&language=${data.language}&KBLanguage=${data.kbLanguage}&CMSAccount=${data.cmsAccount}&CMSCountryCodes=${data.CMSCountryCodes}`
  //   );
  // },
  Update: (data) => {
    // console.log('Update data', data);
    return request.post("/api/Account/Update", data);
  },
  UpdateAvatar: (data) => {
    return request.post("/api/Account/UpdateAvatar", data);
  },
  GetAllCannedResponse: () => {
    return request.get("/api/Account/GetAllCannedResponse");
  },
  SearchCannedResponse: (data) => {
    return request.post("/api/Account/SearchCannedResponse", data);
  },
  AddCannedResponse: (data) => {
    return request.post("/api/Account/AddCannedResponse", data);
  },
  EditCannedResponse: (id, data) => {
    return request.put(`/api/Account/EditCannedResponse/${id}`, data);
  },
  DeleteCannedResponse: (id) => {
    return request.delete(`/api/Account/DeleteCannedResponse/${id}`);
  },
  ForgetPassword: (data) => {
    return request.post("/api/Account/ForgetPassword", data);
  },
  ResetPassword: (data) => {
    return request.post("/api/Account/ResetPassword", data);
  },
  // mail 二次驗證
  SendVerifyLoginMail: (data) => {
    return request.post("/api/Account/SendVerifyLoginMail", data);
  },
  VerifyLoginCode: (data) => {
    return request.post("/api/Account/VerifyLoginCode", data);
  },
};

export const Config = {
  get: () => {
    return request.get("/api/ConfigValue");
  },
};
